import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ResourceManagerService } from '@barthauer/abc/core/resources';
import { BasysMapFrameService } from '@barthauer/basys/map-frame';
import { ResourceEventEditBase } from '../resource-event-edit-base/resource-event-edit-base.component';
import { ResourcesService } from '../resources.service';

@Component({
  selector: 'app-resource-event-material-material-expense',
  templateUrl: './resource-event-material-material-expense.component.html',
  styleUrls: ['./resource-event-material-material-expense.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ResourceEventMaterialMaterialExpenseComponent extends ResourceEventEditBase implements OnInit, OnDestroy {
  constructor(
    resourceManagerService: ResourceManagerService,
    resourcesService: ResourcesService,
    frame: BasysMapFrameService
  ) {
    super();
    super.init(frame, resourcesService, resourceManagerService);
  }

  async ngOnInit() {
    super.ngOnInit();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
